import angular from 'angular';
import SurveyController from './survey.controller';
import Routes from './survey.routes';

import './survey.styles.scss';

export default angular.module('autoboard.survey', [])
  .config(Routes)
  .controller('SurveyController', SurveyController)
  .name;
